import React, { Component } from 'react';
import CreatableSelector from "./CreatableSelector";
import fetcher from '../API';
import _ from 'lodash';
import CommonHeader from "./CommonHeader";
import WeightEditor from "./WeightEditor";
import ProductRichTextSection from './ProductRichTextEditor/ProductRichTextSection';
import { message } from 'antd';

const InventoryStatus = [
    'AVAILABLE',
    'RESERVED',
    'UNAVAILABLE'
];

class AttributesForm extends Component {
    constructor(props) {
        super(props);

        this.onChangeTags = this.onChangeTags.bind(this);
        this.saveMaxPurchaseToServer = this.saveMaxPurchaseToServer.bind(this);
        this.onUpdateEditorail = this.onUpdateEditorail.bind(this);
        this.onChangeInventoryStatus = this.onChangeInventoryStatus.bind(this);

        const { attributes, editorial, tags } = this.props.product;

        let currentMaxPurchase = `0`;
        if (attributes && attributes.attributes && attributes.attributes.purchase_cap) {
            currentMaxPurchase = attributes.attributes.purchase_cap.choices[0];
        }
        this.state = {
            editorial,
            tags,
            maxPurchase: currentMaxPurchase,
            newTags: props.product.tags,
            inventoryStatus: props.product.inventoryStatus
        }
    }

    render() {
        const product = this.props.product;
        return (
            <div>
                <div className="col-md-12">
                    <ProductRichTextSection
                        productId={product.id}
                        initialValue={product.imageText}
                        legacyValue={product.editorial}
                    />
                </div>

                <div className="mt-3">
                    <CommonHeader className="col-md-12 mb-1"
                        headerTitle={ '每单限购：' }
                        buttonTitle={ 'Save' }
                        buttonAction={ this.saveMaxPurchaseToServer } />
                    <div className="col-md-12">
                        <input className="form-control"
                            type="number"
                            onChange={ (event) => { this.setState({ maxPurchase: event.target.value }) } }
                            value={ this.state.maxPurchase } />
                    </div>
                </div>

                <div>
                    <CreatableSelector
                        values={ this.getTagOptions(this.state.newTags) }
                        options={ this.getTagOptions(this.state.tags) }
                        onSelect={ this.onChangeTags }
                        headerView={ <CommonHeader className="col-md-12 mb-1"
                            headerTitle={ '商品标签：' }
                            buttonTitle={ 'Save' }
                            buttonAction={ () => this.saveTagsToServer(this.state.newTags) } /> }
                    />
                </div>

                {
                    !this.props.isSelfSale ? null :
                        <div>
                            <CreatableSelector
                                disableMulti={ true }
                                values={ this.state.inventoryStatus }
                                options={ this.getInventoryStatusOptions(this.state.inventoryStatus) }
                                onSelect={ this.onChangeInventoryStatus }
                                headerView={ <CommonHeader className="col-md-12 mb-1"
                                    headerTitle={ '库存状态（只支持自营商品）：' }
                                    buttonTitle={ 'Save' }
                                    buttonAction={ () => this.saveInventoryStatusToServer(this.state.inventoryStatus) } /> }
                            />
                        </div>
                }

                <div className="mt-3">
                    <WeightEditor productId={ product.id } sizes={ product.sizes } />
                </div>
            </div>
        );
    }

    getTagOptions(tags = []) {
        return tags.map((tag, idx) => ({ label: tag, value: tag }));
    }

    getInventoryStatusOptions() {
        return InventoryStatus.map((invs, idx) => ({ label: invs, value: invs }));
    }

    onChangeTags(newValues) {
        const newTags = newValues.map((value) => {
            return value.value;
        });
        this.setState({ newTags });
    }

    onChangeInventoryStatus(option) {
        this.setState({ 
            inventoryStatus: option.value
        });
    }

    saveTagsToServer(newTags) {
        fetcher.patch(`api/v1/products/${this.props.product.id}/tags`, {
            replace: newTags
        }).then((response) => {
            message.success('保存成功');
        }).catch((error) => {
            alert(error);
        });
    }

    saveInventoryStatusToServer(status) {
        fetcher.post(`api/v1/products/${this.props.product.id}/inventory-status`, {
            status
        }).then((response) => {
            message.success('保存成功');
        }).catch(error => {
            alert(error);
        });
    }

    onUpdateEditorail(newText) {
        this.setState({ editorial: newText });
    }

    saveEditorialToServer(newEditorial) {
        fetcher.post(`api/v1/products/${this.props.product.id}`, {
            'editorial': newEditorial
        }).then((response) => {
            message.success('保存成功');
        }).catch((error) => {
            alert(error);
        });
    }

    saveMaxPurchaseToServer() {
        const count = this.state.maxPurchase;
        fetcher.post(`api/v1/products/${this.props.product.id}/attributes/purchase_cap`, {
            "choices": [count]
        }).then((response) => {
            message.success('保存成功');
        }).catch((error) => {
            alert(error);
        });
    }
    saveInventoryStatus() {
        const count = this.state.maxPurchase;
        fetcher.post(`api/v1/products/${this.props.product.id}/attributes/purchase_cap`, {
            "choices": [count]
        }).then((response) => {
            message.success('保存成功');
        }).catch((error) => {
            alert(error);
        });
    }
}

export default AttributesForm;
